import { useEffect } from "react";

export default function useDisableDevTools() {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      document.addEventListener("contextmenu", (event) =>
        event.preventDefault(),
      );

      // Bloqueia teclas comuns de acesso ao DevTools
      document.addEventListener("keydown", (event) => {
        if (
          event.key === "F12" ||
          (event.ctrlKey &&
            event.shiftKey &&
            ["I", "J", "C"].includes(event.key))
        ) {
          event.preventDefault();
        }
      });
    }
  }, []);
}
